import { jsx as t } from "react/jsx-runtime";
function o(C) {
  return /* @__PURE__ */ t("svg", { fill: "none", height: "24", viewBox: "0 0 24 24", width: "24", xmlns: "http://www.w3.org/2000/svg", ...C, children: /* @__PURE__ */ t(
    "path",
    {
      d: "M22.4765 6.42385C22.2205 5.47024 21.5017 4.72682 20.5422 4.46795C18.8487 4 11.9923 4 11.9923 4C11.9923 4 5.15128 4 3.45771 4.46906C2.51355 4.72682 1.77835 5.47024 1.50703 6.42385C1.05957 8.13746 1.05957 11.7417 1.05957 11.7417C1.05957 11.7417 1.05957 15.3459 1.50703 17.075C1.77835 18.0121 2.51355 18.7721 3.45661 19.0309C5.15128 19.5 11.9912 19.5 11.9912 19.5C11.9912 19.5 18.8476 19.5 20.5422 19.0309C21.5017 18.7721 22.2205 18.0132 22.4765 17.075C22.9404 15.3459 22.9404 11.7417 22.9404 11.7417C22.9404 11.7417 22.9404 8.13746 22.4765 6.42495V6.42385ZM9.81845 15.0705V8.42841L15.4921 11.7417L9.81845 15.0705Z",
      fill: "white"
    }
  ) });
}
export {
  o as default
};
